
export class StockItemCategoryModelDto {
    id: number
    category: string
    type: string


    constructor(

        id: number,
        category: string,
        type: string,
    ) {
        this.id = id
        this.category = category
        this.type = type

    }

}


